
import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { getCategoryDetail_category_categoryBanners as CategoryBanner } from '@/categories/types/getCategoryDetail'
import { IMAGE_VARIANT } from '@/common/const'

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    bannerItems: {
      type: Array as () =>  CategoryBanner[],
      required: true
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.CATEGORY_BANNER
    },
    IMAGE_VARIANT() {
      return IMAGE_VARIANT.CATEGORY_BANNER
    }
  },
  methods: {
    isLink(href: string | null): boolean {
      return href !== ''
    }
  }
})
